import { render, staticRenderFns } from "./IcraTakipKartiTaslak.vue?vue&type=template&id=0a022ed6&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./IcraTakipKartiTaslak.vue?vue&type=script&lang=ts"
export * from "./IcraTakipKartiTaslak.vue?vue&type=script&lang=ts"
import style0 from "./IcraTakipKartiTaslak.vue?vue&type=style&index=0&id=0a022ed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a022ed6",
  null
  
)

export default component.exports